import { Injectable, Type, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AlertContentComponent } from '../../../shared/components/alert/alert-content/alert-content.component';
import { Operation } from '../../models/operations/operation';
import { Echeance } from '../../models/operations/echeance';

interface AlertOpenParams {
  header: string;
  content: string | SafeHtml;
  contentType?: string;
  confirmCallback?: () => void;
  cancelCallback?: () => void;
  params?: unknown;
}

@Injectable({
  providedIn: 'root'
})
export class AlertService {
  private modalService = inject(NgbModal);


  public text = "";
  public head = "";
  public content: SafeHtml = "";

  public open({ header, content, contentType = 'text', confirmCallback, cancelCallback, params }: AlertOpenParams): NgbModalRef {
    const ref = this.modalService.open(AlertContentComponent);
    ref.componentInstance.header = header;
    ref.componentInstance.content = content;
    ref.componentInstance.contentType = contentType;
    if (confirmCallback) {
      (ref.componentInstance as any).confirmCallback = confirmCallback;
    }
    if (cancelCallback) {
      (ref.componentInstance as any).cancelCallback = cancelCallback;
    }
    if (params) {
      (ref.componentInstance as any).params = params;
    }
    return ref;
  }

  public openWithContent(content: Type<unknown>): NgbModalRef {
    return this.modalService.open(content);
  }

  public openWithContentAndParameters(content: Type<unknown>, parameters: unknown[] | unknown): NgbModalRef {
    const modal = this.modalService.open(content, { size: 'lg' });
    if (Array.isArray(parameters)) {
      modal.componentInstance.parameters = parameters;
    } else {
      modal.componentInstance.parameters = [parameters];
    }
    return modal;
  }
  public openWithContentAndSize(content: Type<unknown>, size: string): NgbModalRef {
    return this.modalService.open(content, { size: size });
  }

  public openOperation(operation: Operation, content: Type<unknown>): NgbModalRef {
    const modal = this.modalService.open(content, { size: 'lg' });
    modal.componentInstance.operation = operation;
    return modal;
  }

  public openEcheance(echeance: Echeance, content: Type<unknown>): NgbModalRef {
    const modal = this.modalService.open(content, { size: 'lg' });
    modal.componentInstance.echeance = echeance;
    return modal;
  }
}
